import React from "react";
import { useTranslation } from "react-i18next";
import { AddToListButton, SparkIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import SubtasksBodyTemplate from "./SubtasksBodyTemplate.jsx";
import { AiButton } from "../AiButton/AiButton.js";

const SubtasksBodyWithoutItems = ({ onClick, isTaskCompleted, onSuggest, visible, showSuggestButton }) => {
  const { t } = useTranslation();

  if (!visible || isTaskCompleted) {
    return null;
  }

  return (
    <SubtasksBodyTemplate>
      <div className="parent_add_mode_trigger tw-mb-4">
        <div className="tw-flex tw-justify-between tw-items-center">
          <AddToListButton
            text={t("Add a Subtask")}
            onClick={onClick}
            className="tw--ml-1"
          />
          {showSuggestButton ? (
            <AiButton onClick={onSuggest}>
              <SparkIcon className="tw-h-4 tw-w-4" />
              <span>{t("Suggest Subtasks")}</span>
            </AiButton>
          ) : null}
        </div>
      </div>
    </SubtasksBodyTemplate>
  );
};

SubtasksBodyWithoutItems.propTypes = {
  onClick: PropTypes.func,
  isTaskCompleted: PropTypes.bool,
  onSuggest: PropTypes.func,
  visible: PropTypes.bool.isRequired,
  showSuggestButton: PropTypes.bool,
};

SubtasksBodyWithoutItems.defaultProps = {
  onClick: () => {},
  isTaskCompleted: false,
  onSuggest: () => {},
  visible: false,
};

SubtasksBodyWithoutItems.displayName = `SubtasksBodyWithoutItems`;

export default SubtasksBodyWithoutItems;
